// extracted by mini-css-extract-plugin
export default {"menuBlock":"tF-z","title":"uF-z","nav":"vF-z","flexCell":"wF-z","facetLink":"xF-z"};